import React from 'react';
import moment from 'moment/moment';
import { WayPoint, AddressFormat, TaskInventory } from '@bringg/types';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { AddressKeys } from './waypoint-card.consts';

export const getFormattedAddress = (wayPoint: WayPoint, addressFormat: AddressFormat): string => {
	let formattedAddress = '';
	const defaultAddressKeys: string[] = [AddressKeys.ADDRESS, AddressKeys.CITY, AddressKeys.ZIPCODE];
	const addressKeys = addressFormat?.values?.length ? addressFormat.values : defaultAddressKeys;
	addressKeys.forEach(addressKey => {
		const key = addressFormat?.values?.length ? addressKey.key : addressKey;
		if (Object.values(AddressKeys).includes(key)) {
			formattedAddress = addFieldToAddress(formattedAddress, wayPoint[key]);
		}
	});
	return formattedAddress;
};

export const addFieldToAddress = (currentAddress: string, field: string): string => {
	if (!field) {
		return currentAddress;
	}

	if (currentAddress) {
		currentAddress += ', ';
	}

	currentAddress += field;

	return currentAddress;
};

export const tabPaneTitle = (title: string, icon: BringgFontIcons): React.ReactNode => {
	return (
		<span className="waypoint-card-tab-label">
			<BringgIcon iconName={icon} />
			{title}
		</span>
	);
};

export const checkForRejectedInventories = (inventoriesArray: TaskInventory[]): boolean => {
	let hasRejected: boolean = false;
	const isRejected = inventoriesArray.some((inventory: TaskInventory) => {
		if (inventory.rejected_quantity > 0) {
			hasRejected = true;
		} else if (inventory.inventories?.length && !hasRejected) {
			hasRejected = checkForRejectedInventories(inventory.inventories);
		}
		return hasRejected;
	});
	return isRejected;
};

export const getTOS = (checkinTime, checkoutTime) => {
	return checkoutTime ? moment.duration(moment(checkoutTime).diff(moment(checkinTime))).asSeconds() : -1;
};
